import { useMutation } from "@tanstack/react-query"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import styles from "./styles.module.scss"
import { createTripRoom } from "../../../services/firebase-functions/rooms"
import { CreateTripRoomInput } from "@cruisen/contract"
import FormTextInput from "../../atoms/FormTextInput"
import { colors } from "@theme/colors"

type RoomFormValues = {
  roomName: string
}

const roomSchema = yup.object().shape({
  roomName: yup.string().required("-"),
})

export const AddRoomForm = ({
  tripId,
  defaultName,
  closePopover,
}: {
  tripId: string
  defaultName: string
  closePopover: () => void
}) => {
  const { mutateAsync: mutateAddRoom, isPending } = useMutation({
    mutationFn: (data: CreateTripRoomInput) => createTripRoom(data),
  })

  const createRoom = async (values: RoomFormValues) => {
    await mutateAddRoom({
      roomData: {
        name: values.roomName,
        cabinTypePreferences: [],
      },
      tripId,
    })
    closePopover()
  }

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm({
    defaultValues: {
      roomName: defaultName || "",
    },
    resolver: yupResolver(roomSchema),
  })

  return (
    <form
      className={styles.addRoomForm}
      onSubmit={(e) => {
        e.preventDefault()
        handleSubmit(createRoom)()
      }}
    >
      <FormTextInput
        control={control}
        autoFocus
        name="roomName"
        label="Room name"
        parentBackgroundColor={colors.backgroundQuaternary}
        lightOutline={true}
      />
      <button
        type="submit"
        disabled={isPending || !isValid}
        className={styles.confirmButton}
        data-testid="create-room-button"
      >
        {isPending ? "Adding room..." : "Add room"}
      </button>
    </form>
  )
}
